<div class="option-list">
  <table>
    <thead>
    <tr>
      @if (culture !== 'en') {
        <th>Text</th>
      }
      <th>{{ culture === 'en' ? 'Text' : 'Translation' }}</th>

      @if (culture === 'en') {
        <th></th>
      }
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let option of element.options; let i = index">
      @if (culture !== 'en') {
        <td><div class="fake-field disabled">{{ option.text }}</div></td>
      }
      <td>
        <div class="fake-field disabled" [class.visibility-hidden]="optionIsEditable(option)">{{ getOptionText(option)}}</div>
        <input type="text" class="form-control option-text" [placeholder]="culture === 'en' ? 'Enter text...' : 'Enter translation...'" [value]="getOptionText(option)" (input)="onOptionTextChange(i, $event)" [class.visibility-hidden]="!optionIsEditable(option)" [class.ng-touched]="getOptionText(option).trim().length === 0" [class.ng-invalid]="getOptionText(option).trim().length === 0" />
      </td>

      @if (culture === 'en') {
        <td class="column-options">
          <div class="option-actions">
            <button type="button" (click)="removeOption(i)" [class.visibility-hidden]="!optionIsRemovable(option)">&#10005;</button>
            <button type="button" (click)="moveOptionUp(i)" [disabled]="i === 0">&#8593;</button>
            <button type="button" (click)="moveOptionDown(i)" [disabled]="i === element.options.length - 1">&#8595;</button>
          </div>
        </td>
      }
    </tr>
    </tbody>
  </table>
</div>

<div class="add-option-container">
  <app-button text="+ Add Option" variant="info" type="button" size="sm" (click)="addOption()" />
</div>
